// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3iM3G","rootSuccess":"CompleteLink_rootSuccess__3p6zl","rootFailure":"CompleteLink_rootFailure__3k7TC","isDisabled":"CompleteLink_isDisabled__7pmc0"};